// ============================================================================
// ADAYA PORTFOLIO DEMO CONFIG
// ----------------------------------------------------------------------------
// This file exists only for the local, dummy-data portfolio demo. It powers a
// fake logged-in session so the real product UI can be clicked through and
// redesigned without the live NestJS/Mongo/BigQuery backend or Meta Ads API.
//
// Flagship demo brand: "Solene" — a premium DTC skincare brand (Meta + Shopify).
// Numbers elsewhere are tuned to a best-in-class account that fits the Adaya
// story. Rename the brand / goals here and it flows through the whole app.
// ============================================================================

export const DEMO_MODE = true;

export const DEMO_BRAND = {
    name: 'Solène',
    domain: 'solene.co',
    currency: 'USD',
    timezone: 'America/New_York',
    // Monthly goals surfaced on Goal Tracker / Goal Studio / MER, etc.
    goals: {
        revenueGoal: '850000', // monthly revenue target
        cppGoal: '34',         // target cost per purchase
        aovGoal: '96',         // target average order value
        roasGoal: '3.4',       // target blended ROAS
    },
};

// A date far enough in the past that the account is "mature" (all features on).
const JOINED = new Date('2021-06-01T00:00:00Z');
const LINKED = new Date('2021-06-02T00:00:00Z');

export const demoAccount: any = {
    _id: 'demo-acct-solene',
    id: 'demo-acct-solene',
    name: DEMO_BRAND.name,
    accountId: 'act_1029384756610',
    currency: DEMO_BRAND.currency,
    storeInfo: {
        currency: DEMO_BRAND.currency,
        timezone: DEMO_BRAND.timezone,
        name: DEMO_BRAND.name,
        domain: DEMO_BRAND.domain,
    },
    tracking: {
        trackingId: 'De-solene0001',
        domains: DEMO_BRAND.domain,
        dateCreated: JOINED,
        enabled: true,
        config: {},
    },
    providers: [
        { name: 'Facebook', accountId: 'act_1029384756610', oauth: { ok: true }, dateLinked: LINKED, lastUpdated: LINKED },
        { name: 'Shopify', accountId: 'solene.myshopify.com', oauth: { ok: true }, dateLinked: LINKED, lastUpdated: LINKED },
    ],
    accountUsers: [],
    // Monthly goals. cpp/orders/adspend are DERIVED by getGoal() from these.
    // Actuals run best-in-class (slightly ahead of target).
    metadata: {
        goals: {
            revenue: 1150000, // monthly store revenue target
            mer: 3.5,         // media efficiency ratio target
            roas: 3.5,        // blended ROAS target
            aov: 95,          // average order value target
        },
    },
    createdAt: JOINED,
};

export const demoUser: any = {
    _id: 'demo-user-alicia',
    id: 'demo-user-alicia',
    email: 'alicia@solene.co',
    isVerified: true,
    name: 'Alicia Evergreen',
    avatar: undefined,
    sub: 'demo|alicia',
    roles: ['admin', 'user'],
    dateJoined: JOINED,
    lastLogin: new Date(),
    // raw "auth0-style" user metadata the app reads for goal defaults
    metadata: {
        cppGoal: DEMO_BRAND.goals.cppGoal,
        revenueGoal: DEMO_BRAND.goals.revenueGoal,
        aovGoal: DEMO_BRAND.goals.aovGoal,
        roasGoal: DEMO_BRAND.goals.roasGoal,
    },
    activeAccount: demoAccount,
    accounts: [demoAccount],
};
